import React from "react";
import { Divider } from "../../BP2Components";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import PictureWebSettings from "../WidgetsSettings/WebWidgets/PictureWeb/PictureWebSettingsModal";
import IntlMessages from "@util/IntlMessages";

const PictureWebWidget = ({ value, role }) => {
   return (
      <>
         <Widget
            styleName="gx-m-0"
            bgColor={value.backgroundColourHex}
            title={<IntlMessages id="web.pictureWidget" />}
            role={role}
            extra={
               (role === "OWNER" || role === "MODERATOR") && (
                  <SettingsModal
                     widgetId={value.id}
                     widgetName={value.name}
                     icon="setting"
                     deleteIcon="true"
                     children={<PictureWebSettings value={value} />}
                  />
               )
            }
         >
            <strong>
               <IntlMessages id="settings.textString" /> :
            </strong>{" "}
            {value.textString}
            <Divider />
            <strong>
               <IntlMessages id="settings.hrefString" /> :
            </strong>{" "}
            {value.hrefString}
            <Divider />
            <strong>
               <IntlMessages id="settings.fileName" /> :
            </strong>{" "}
            {value.fileName}
            <Divider />
            <strong>
               <IntlMessages id="settings.widgetKey" /> :
            </strong>{" "}
            {value.widgetKey}
         </Widget>
      </>
   );
};

export default PictureWebWidget;
